export enum StatusEnum {
  Habilitado = 1,
  HabilitadoDescription = 'Habilitado',
  Desabilitado = 2,
  DesabilitadoDescription = 'Desabilitado',
  Pendente = 3,
  PendenteDescription = 'Pendente',
  Suspenso = 4,
  SuspensoDescription = 'Suspenso',
  Cancelado = 5,
  CanceladoDescription = 'Cancelado',
  EmCredenciamento = 6,
  EmCredenciamentoDescription = 'Em Credenciamento',
  EmAnalise = 7,
  EmAnaliseDescription = 'Em Análise',
  Aprovado = 8,
  AprovadoDescription = 'Aprovado',
  Reprovado = 9,
  ReprovadoDescription = 'Reprovado',
  Vencido = 10,
  VencidoDescription = 'Vencido',
  PendenteCAR = 11,
  PendenteCARDescription = 'Pendente CAR'
}
